export default {
    list: [
        { "id": "01", "name": "数字经济赋能传统产业", "count": 0, "select": "",src:"./img/001.jpg",w:500,h:333,title:`<p class="aux">
 杭州提出要打造全国数字经济第一城，为数字中国建设当好先锋、提供样本。杭州围绕“数字产业化、产业数字化、城市数字化”，正在走出一条“以数字经济驱动发展变革”的创新之路。</p>
 <br> • 大江东数字经济和高端制造融合创新高地。<br> •
总投资200亿元的高性能动力电池项目落户大江东。<br> •
总投资10亿美元的中芯晶圆大尺寸半导体硅片项目开工建设。<br> •
万事利集团：以丝绸文化创意为主业的现代化企业集团。<br> •
中策橡胶：集轮胎研发、生产、销售与汽车后市场服务为一体的大型轮胎企业。<br> •
达利国际集团：全球知名丝绸纺织及服装企业，专营高档男女真丝产品。<br> •
恒逸石化：致力于发展成为全球领先的石化和化纤综合服务商。<br> •
老板电器：经过三十年市场检验的专业厨房电器生产企业。<br> •
德意电器：结合德国、意大利美学品位，打造的中国厨电品牌。<br> •
葳芸旗袍：有着80多年的传承历史的旗袍品牌。<br> •
王坚：城市大脑技术总架构师。<br> •
沈金荣：中策橡胶集团有限公司董事长，总经理。<br> ` },
        { "id": "02", "name": "匠人匠心铸就杭州制造", "count": 0, "select": "",src:"./img/002.jpg",w:500,h:332,title:`<p class="aux">
        近年来，杭州高端装备制造业不断崛起。2018年10月，第一架中国自行研制的水陆两用大飞机“鲲龙”AG600试飞成功，来自杭州的西子航空是大飞机一级机体结构供应商中唯一的民营企业。</p>
        <br> • 杭州市总工会：2018年第二届“杭州工匠”评选活动。<br> •
冯有林：杭州植物园花卉园艺技师。<br> •
余号德：杭州燃气集团燃气管道抢修高级技师。<br> •
张孝宅：中国美术学院文物修复师。<br> •
金国荣：萧山金国荣青瓷艺术馆南宋官窑美术工艺师。<br> •
杨金龙、蒋应成：杭州技师学院喷漆技师。<br> •
张小泉：杭州老字号转型代表企业。<br> •
郑捷：中国美术学院风景建筑设计研究总院有限公司（景观）总建筑师，兼人文景观研究院院长。<br> •
杭汽轮：以装备制造业为核心的国有上市公司。<br> •
杭氧集团：以制造空气分离设备和工业气体为主的大型企业集团。<br> •
西子航空、杭锅集团：西子联合旗下的新生代“杭州造”与传统制造业再升级。<br> ` },
        { "id": "03", "name": "原创研发驱动迭代发展", "count": 0, "select": "",src:"./img/003.jpg",w:500,h:333,title:`<p class="aux">
        杭州是一座历史悠久的城市，也是一座创新活力之城，近年来，打造之江实验室为主的全球一流科技创新平台，创建西湖大学为首的新型研究型大学，不断集聚和提升环境、载体、人才、资本、政策等创新要素，努力向着具有全球影响力的“互联网＋”创新创业中心奋进。</p>
        <br> • 2019年3月，《2019杭州独角兽&准独角兽企业榜单》发布。<br> •
2018年8月，未来科技城科创园区联盟全员大会暨扩大会议召开。<br> •
2018年9月，阿里达摩院官网正式上线，公开5大研究领域。<br> •
第二届未来生活节：以“科技+人文”的方式进行，由都市快报举办。<br> •
西湖大学成立：由社会力量举办、国家重点支持的新型研究型大学。<br> •
阿里-浙大前沿技术联合研究中心：入驻中国杭州人工智能小镇。<br> •
杭州光启人工智能研究院：人工智能领域的重量级企业，在未来科技城揭幕。<br> •
百度（杭州）创新中心：举办人工智能产业论坛。<br> •
之江实验室：落户杭州一周年，以创建国家实验室为发展目标打造。<br> •
施一公：西湖大学首任校长。<br> •
韩璧丞：BrainCo创始人、CEO，曾入选福布斯中国30位30岁以下精英榜。<br> ` },
        { "id": "04", "name": "都市圈扩容筑梦长三角", "count": 0, "select": "",src:"./img/004.jpg",w:500,h:354,title:`<p class="aux">
        随着浙江衢州市、安徽黄山市正式加入杭州都市圈，四市一体转变为六市一体，杭州都市圈正式进入3.0时代。衢州和黄山的加入，打通了长三角金南翼西进通道，对于推进长三角城市群建设意义非凡。</p>
        <br> • 2018年12月25日，杭黄高铁首发，打通了长三角南翼西径的大通道。<br> •
黄山市工商局与杭州市场监督管理局正式签订合作备忘录。<br> •
杭州都市圈第九次市长联席会议：批准衢州市、黄山市加入杭州都市圈。<br> •
黄山市：加入杭州都市圈，吸引兴办企业近300家，总投资额逾200亿元。<br> •
衢州市：加入杭州都市圈，新时代的徽商积极投身都市圈城市创业兴业。<br> •
周晓国：通过组织自驾游的形式促进杭黄两地人们生活的融合。<br> •
方向明：发动衢州偏远山区农户种植蔬菜，让杭州市民真正吃上农民自家菜。<br> ` },
        { "id": "05", "name": "城市大脑引领智慧治理", "count": 0, "select": "",src:"./img/005.jpg",w:500,h:320,title:`<p class="aux">
        在杭州，跨行业、跨领域的大数据资源开发，唤醒了越来越多“沉睡”的数据。2018年，杭州城市大脑（综合版）正式发布，意味着城市大脑从交通领域向城管、卫生健康、旅游、环保等领域全面延伸，从而真正建立智慧城市的中枢系统。</p>
        <br> • 杭州城市大脑（综合版）发布，九项惠民举措正式上线。<br> •
24小时综合服务机：凭身份证即可办理社保等个人事项的便民服务设施。<br> •
杭州办事APP：杭州本地的网上办理政务服务软件。<br> •
刷脸智慧医疗：“互联网+医疗健康”系统的智慧医疗项目之一。<br> •
慢病长处方，智慧云药房：全省首创的慢性病连续处方线上平台。<br> •
建筑工地融媒体：着眼于关爱民工精神文化生活的新平台和新模式。<br> •
智慧公交管理平台：大数据下为公交公司、政府和民众服务的线上平台。<br> •
余杭区第一人民医院：刷脸智慧医疗的第一试点医院。<br> •
杭州市红十字会医院：创新电子社保卡实现互联网支付，全程无卡就医。<br> •
孙敏：余杭区第一人民医院智慧医疗项目执行者。<br> •
蒋天武：长庆潮鸣街道社区卫生服务中心“慢病长处方，智慧云药房”执行者。<br> ` },
        { "id": "06", "name": "社区服务追求美好生活", "count": 0, "select": "",src:"./img/006.jpg",w:500,h:333,title:`<p class="aux">
        社区是人民群众安居乐业的家园，杭州的社区用自身的活力诠释着具有这座城市特质的创新管理。“不赚钱”的老年食堂、片组管理的中小幼食堂、国际化的农贸市场、产城融合的公共配套，让老百姓的生活圈变身“幸福圈”。</p>
        <br> • 拱墅区成立浙江首个“三方办”， 党建引领物业改革，破解社区治理难问题。<br> •
民生工程“老小区加装电梯”项目成功落实社区——上城区南光坊。<br> •
丁兰模式：城北新城核心区块“丁桥”成为杭州中心区山水城市。<br> •
绿城桃源小镇：打造集“衣食住行游购娱学”于一体的城市耕读文化的小镇。<br> •
绿城观云小镇：提倡“离尘不离城”的中式慢生活的生活小镇。<br> •
蓝城桃李春风小镇：中国家庭颐乐生活新里程。<br> •
融创“书享月”：为不同阅读对象提供有趣“读”法的文化分享方式。<br> •
万科良渚“晓书屋”：由世界级建筑师打造的社区文化艺术空间。<br> •
杭州市城市土地发展有限公司：坚持“以民为先”土地开发新理念的国有企业。<br> •
上城区既有住宅加装电梯办公室：市住保房管局牵头联动的执行单位。<br> •
吴江达：多年来深耕民生领域，致力打造杭州第一社区老年食堂。<br> ` },
        { "id": "07", "name": "加装电梯提升幸福指数", "count": 0, "select": "",src:"./img/007.jpg",w:500,h:333,title:`<p class="aux">
        “既有住宅加装电梯”连续三年入选杭州“十大民生实事”。截至2018年年底，杭州共有531处加装电梯项目通过联合审查，397处项目开工。以多赢思维看“老小区加装电梯”，可以认识到这项民生工程的价值所在。</p>
        <br> • 江干区启用全国首台“浅基坑”既有住宅加装电梯。<br> •
上城区老小区加装电梯：上城区新民村2幢1单元，杭州第一个加装电梯项目。<br> •
江干区老旧小区改造：老小区加装电梯，推进老年宜居住宅建设。<br> •
上城区南光坊：老小区加装电梯项目工作落实的典型示范单位之一。<br> •
上城区望江社区街道：老小区加装电梯项目工作落实的典型示范单位之一。<br> •
上城区既有住宅加装电梯办公室：市住保房管局牵头联动的执行单位。<br> •
何海元：上城区清波街道新民村小区住户，老小区加装电梯发起人之一。<br> ` },
        { "id": "08", "name": "乡村历史建筑蝶变重生", "count": 0, "select": "",src:"./img/008.jpg",w:500,h:272,title:`<p class="aux">
        2018年，杭州推出了涵盖13个区、县（市）的28个历史建筑保护利用试点项目，深奥古村怀荆堂、新叶古村翰墨轩、叶家村叶氏宗祠等乡村历史建筑蝶变重生。当前，杭州已基本实现历史建筑保护利用管理体系“都市—城镇—农村”全域覆盖。</p>
        <br> • 《杭州市历史建筑保护利用试点工作方案》的实施。<br> •
东梓关村历史建筑群：在“美丽乡村”建设中走在全国前列的江南民居。<br> •
江南明清古建筑博物馆：位于西溪湿地公园，内有明清时期原汁原味的古民居、厅堂、宗祠等。<br> •
湖边邨建筑群：为民国时期修建，已列入杭州历史建筑保护名录。<br> •
罗家老宅历史建筑：建于清道光年间的纯正徽式风格宅院。<br> •
航空小镇工业遗产：建德寿昌结合“乡村振兴”战略实施打造特色小镇。<br> •
淳安叶家村叶氏宗祠：为明代十二世的天宦公与十三世的雁鸣公等人领建。<br> •
临安白果村里仁55、56号民居：坐落于清凉峰镇的典型徽派风格建筑。<br> •
周寅：萧山区河上镇凤凰坞村抗战纪念馆建筑群修复再建的发起者。<br> •
何晓华：富阳区大源镇文体中心主任。<br> •
周仁花：富阳区文物馆文保科长。<br> ` },
        { "id": "09", "name": "艺术展览会花开综合体", "count": 0, "select": "",src:"./img/009.jpg",w:500,h:305,title:`<p class="aux">
        随着消费升级，在杭州，“购物”不再是商场的唯一表达方式，文化艺术的介入改变了传统购物中心的形象，使商场不再局限于提供衣食住行、吃喝玩乐，更趋向于满足群众对文化和精神层面的消费需求，转型成为一座艺术的殿堂。</p>
        <br> • 万象汇，艺术公益事件：“2018爱聚万象——100个白日梦展”。<br> •
远洋乐堤港：与芬兰著名插画艺术家合作，打造魔法奇境城堡。<br> •
嘉里中心：举办杭州.Me系列活动，关注并支持杭州原创力量。<br> •
金沙天街：以艺术泡面展、n次元音乐节打造时空筑梦破次元缤纷圣诞季。<br> •
杭州大厦：城市商业标杆，转型多种艺术形态。<br> •
滨江天街B馆万芳：为在新购物空间营造、IP打造和服务相融合做创新注解。<br> •
席挺军：恒庐美术馆馆长，以国大城市广场为起点，倾力打造新型城市综合体。<br> •
快房传媒K-Media：新晋媒体宣传推广企业，致力于企业文化艺术展会等形式的落地。<br> ` },
        { "id": "10", "name": "大城小事讲述温暖故事", "count": 0, "select": "",src:"./img/010.jpg",w:500,h:292,title:`<p class="aux">
        杭州是一座温暖的城市。从斑马线的文明礼让，到92路公交司机为盲人报站，杭州的最美正从“盆栽”变为“风景”。从一个人的无私到一群人的贡献再到一座城市的参与，杭州的暖心将汇聚起更大的力量，成为一座城市的风度。</p>
        <br> • 浙二医院综合ICU举办病房音乐会。<br> •
方回春堂10年如一日向市民提供茶水，冬御严寒，夏解暑热。<br> •
西湖微笑亭的“红马甲”：杭州城市服务的“最美志愿者”。<br> •
杭州火车东站志愿者亭：以“微笑”服务、贴心服务为旅客平安出行助力。<br> •
“92路”公交车司机群体：关爱视障人士，为弱势群体乘客多停留。<br> •
宋忠赤：最美杭州人之一。18年里，曾给杭州提过数百项意见。<br> •
钟鸿亮： 83岁高龄的守泉人，已守护虎山公园的双鱼泉17年。<br> ` },
        { "id": "11", "name": "信用体系构建城市ID", "count": 0, "select": "" ,src:"./img/011.jpg",w:500,h:332,title:`<p class="aux">
        2018年1月9日，国家发改委和中国人民银行公布首批12个社会信用体系建设示范城市。杭州以总评第一的成绩位居榜首。</p>
        <br> • 杭州市发改委牵头推出杭州城市个人信用分——钱江分。<br> •
第五届中国（杭州）国际电子商务博览会在杭州国际博览中心成功举行。<br> •
连连支付：浙江省级高新企业，中国行业支付解决方案提供商。<br> •
芝麻信用：蚂蚁金服旗下独立的第三方征信机构，为用户、商户提供信用服务。<br> •
杭州市民卡APP：致力为杭州市民的生活提供公共服务的城市应用服务平台。<br> •
江苏银行杭州分行：以大数据等技术，打造专业服务小微企业的“智慧银行”。<br> •
杭州银行：于“2018全球银行1000强”榜单中跃升29位。<br> •
潘国栋：连连支付CEO，全球电商领袖代表人物之一。<br> `},
        { "id": "12", "name": "工业生态趋向环境友好", "count": 0, "select": "",src:"./img/012.jpg",w:500,h:321,title:`<p class="aux">
        近年来，杭州坚决贯彻“绿水青山就是金山银山”理念，坚持生态优先、环境立市、绿色发展。2018年，杭州市完成124家污染企业关停转迁，并在全国率先实施机动车排放实时动态监管。</p>
        <br> •富阳拆掉全部造纸厂打造“江南新城”。<br> •
下沙沿江大道：集交通、休闲、健身、运动和景观等功能与一体的景观大道。<br> •
闻涛路：钱塘江南岸的“最美跑道”，杭州最火的“绿道”之一。<br> •
之江东路：从1号大街路口开始到江东大桥的一段路，钱塘江北岸的“绿道”。<br> •
林东：绿盛集团董事长，支持研发世界领先的海流能发电，布局潮汐发电项目。<br> ` },
        { "id": "13", "name": "电竞数娱走近寻常百姓", "count": 0, "select": "",src:"./img/013.jpg",w:500,h:333,title:`<p class="aux">
        杭州正在倾力打造一个全国规模最大的电子竞技生态园区——电竞数娱小镇，它集电竞、直播、演艺、旅游等于一体。目前小镇已经成功引入了125家企业。这里还将大力发展旅游业，打造成能接纳200万人次的3A级景区。</p>
        <br> • 2018年6月，浙江东方职业学院成立浙江省首个电竞学院。<br> •
下城区设立促进电竞数娱小镇产业发展专项资金。<br> •
海蓝国际电竞数娱中心：下城区推进北部城市形态、产业布局改造提升。<br> •
米趣科技：反复尝试中瞄准电竞产业方向，用技术创新驱动企业发展。<br> •
LDG电子竞技俱乐部：中国现存最老牌的电子竞技俱乐部之一，创建于杭州。<br> ` },
        { "id": "14", "name": "音乐生活丰富文化之夜", "count": 0, "select": "",src:"./img/014.jpg",w:500,h:330,title:`<p class="aux">
        近年来，杭州的音乐生活随着《遇见大运河》绵延舒展。2018年，浙江国家音乐产业基地萧山园区落户钱江世纪城，这是全国的第五个音乐产业基地，音乐之都又向前迈进了一步。</p>
        <br> •国家新闻出版广电总局正式批复同意创建浙江国家音乐产业基地，落户萧山。<br> •
杭州爱乐乐团成立10周年，以“杭州速度”向国际化迈进。<br> •
网易云音乐：作为第五个国家音乐产业基地的核心正式上线。<br> •
崔巍：创作的世界文化遗产传播剧《遇见大运河》，完成第一阶段的世界巡演。<br> ` },
        { "id": "15", "name": "放心食品筑牢安全防线", "count": 0, "select": "",src:"./img/015.jpg",w:500,h:329,title:`<p class="aux">
        让居民能够“吃的好”“吃的健康”是提升生活幸福感的一项重要内容。目前，杭州市每天有近5万老年人享受不同形式的助餐服务，各类机构、食堂通过配备专业营养师、设立监督管理委员会等方式，为食品安全筑牢防线。</p>
        <br> • 浙江移动联手浙大跨界茶产业开展“NB-IoT+区块链龙井茶溯源”项目。<br> •
源本生活：山清水秀农业开发有限公司旗下定位高端的生鲜服务品牌。<br> •
智慧食堂：提前实现“未来”食堂的杭十一中食堂，在全国率先推出刷脸点餐。<br> •
晶星都市村：杭州新型都市休闲观光农业基地。<br> •
蔡祖明：祖名豆制品股份有限公司董事长。<br> ` },
        { "id": "16", "name": "民营博物馆呈现新热点", "count": 0, "select": "",src:"./img/016.jpg",w:500,h:372 ,title:`<p class="aux">
        民营博物馆繁荣程度是一个地区文化发展水平的重要指标。近年来，杭州民营博物馆持续升温，江南锡器博物馆、萧山金国荣青瓷艺术馆、高氏照相机博物馆等，讲述着民间收藏的动人故事。</p>
        <br> • 家在钱塘——杭州市农村历史建筑保护与利用九年成果展。<br> •
非国有博物馆藏品档案备案工作，完成藏品备案16万余件。<br> •
江干区：打造家门口的文化乐园。<br> •
杭州西湖丝绸文化博物馆。<br> •
杭州土火斋古陶器博物馆。<br> •
杭州世界钱币博物馆。<br> •
杭州宋代玉器艺术馆。<br> •
杭州万事利丝绸文化博物馆。<br> •
杭州市萧山区吴越历史文书博物馆。<br> •
嵇锡贵: 杭州西溪贵山窑陶瓷艺术馆馆长。<br> •
王保进：杭州江南明清古建筑博物馆馆长。<br> •
高继生: 杭州高氏照相机博物馆馆长。<br> •
陈建明：杭州江南锡器博物馆馆长。<br> •
孙铁：杭州胡庆余堂中医药博物馆成员。<br> `},
        { "id": "17", "name": "新商业模式倡导新生活", "count": 0, "select": "",src:"./img/017.jpg",w:500,h:317,title:`<p class="aux">
        新零售是以信息技术为驱动，以消费者体验为核心的泛零售商业模式。作为国际电子商务中心城市和“新零售”策源地， 2018年，《关于推进新零售发展（2018~2022）若干意见》发布，杭州将在全国率先建成“新零售示范城市”。</p>
        <br> • 盒马鲜生：阿里巴巴对线下超市完全重构的新零售业态。<br> •
五芳斋：以“老字号+新零售”模式，打造了全国首家高速餐饮新零售店。<br> •
永辉超市：针对百万级的会员资源池，进行大数据分析的全新营销战略。<br> •
天猫一小时达：一站式解决老百姓的家庭一日三餐、日用消费等。<br> ` },
        { "id": "18", "name": "新农人渐成乡村生力军", "count": 0, "select": "",src:"./img/018.jpg",w:500,h:327,title:`<p class="aux">
        近年来，新农人成为杭州乡村振兴的主力军。他们是具有现代意识的新型农民，是城乡各类创业者、运营商、企业主，通过与当地村委会合作，高效地整合农村各类资源，发展新农业、建设新乡村、共享新生活。</p>
        <br> • 杭州首届“村民论坛”暨寻访杭州“新农人”活动。<br> •
首届“中国（杭州）美丽乡村丰收节”“乡村丰收人物”评选。<br> •
艺福堂：杭州市首批大学生创业企业，集生产、销售、科研为一体的现代茶企。<br> •
蓝郡农业科技有限公司：以经营农业技术开发及生态农业观光服务等为主。<br> •
下姜村民宿“栖舍”：位于下姜村的一家精品民宿，由返乡人姜丽娟创办。<br> •
祖名豆腐：集研发、生产、销售于一体的大型豆制品生产企业。<br> •
张高立：浙江恒泽生态农业科技有限公司董事长兼总经理。<br> •
蒋海军：浙江山清水秀农业开发有限公司董事长兼总经理。<br> •
周华诚：作家，资深媒体人，“父亲的水稻田”文创项目创始人。<br> ` },
        { "id": "19", "name": "国际赛会推进国际化", "count": 0, "select": "",src:"./img/019.jpg",w:500,h:375,title:`<p class="aux">
        杭州正处于放大“后峰会效应”、着力建设世界名城的攻坚阶段。2018年，世界短池游泳锦标赛的举办，世界旅游联盟总部的落户，成为杭州全面提升城市国际化水平的催化剂。</p>
        <br> • 世界旅游联盟总部落户萧山湘湖国家旅游度假区。<br> •
总部设于杭州的国际丝绸联盟在意大利科莫举行国际丝绸联盟主席扩大会议。<br> •
“杭州国际日”的设立：杭州确定永久设立9月5日为“杭州国际日”。<br> •
第14届FINA世界游泳锦标赛在杭州举行：世界最高级别的泳坛盛会。<br> •
杭州国际社区：为在杭外籍人士搭建安居乐业的平台。<br> •
“2018杭州全球旗袍日”活动：向世界诠释杭州人的新生活美学。<br> •
广兴堂国医馆：一处清代古建筑内，为杭州市最佳国际旅游访问点之一。<br> •
金长：社会资源国际旅游示范访问点“古荡农贸市场”总经理。<br> •
鸿志远：在杭州的外国创客，Nihao App创始人。<br> ` },
        { "id": "20", "name": "文化IP赋能新兴产业", "count": 0, "select": "",src:"./img/020.jpg",w:500,h:352,title:`<p class="aux">
        文化IP能赋能一座城，并与城市文化融合激发出更多活力。曾经新白娘子传奇是杭州的大IP，2018年杭州与腾讯动漫达成三年深度合作，要打造更多的文化IP把杭州塑造成梦幻之城。</p>
        <br> • 杭州体验日暨八·一七稻米节活动举办。<br> •
以“网生迭代”为主题的2018西湖IP大会举办。<br> • 
杭州运河（国家）广告产业园开园：拱墅区广告产业园项目工作推进。<br> •
西子猫猫：杭州西湖风景名胜资产经营集团打造的杭州IP形象。<br> ` },
    ],
    filter(id) {
        var data = this.list;
        var item = null;
        for (var i = 0, len = data.length; i < len; i++) {
            if (data[i].id == id) {
                item = i;
                return data[item]
            }
        }
        return {};
    },
    fmtData() {
        var data = this.list;
        var result = [];

        data.map((item) => {
            if (item.select) {
                result.push(item.select)
            }

        })
        return result.join(',')
    },
    fmtUrl() {
        var args = {};
        var match = null;
        var search = decodeURIComponent(location.search.substring(1));
        var reg = /(?:([^&]+)=([^&]+))/g;
        while ((match = reg.exec(search)) !== null) {
            args[match[1]] = match[2];
        }
        return args;
    },
    ajax(options) {
        //格式化参数
        function formatParams(data) {
            var arr = [];
            for (var name in data) {
                arr.push(encodeURIComponent(name) + "=" + encodeURIComponent(data[name]));
            }
            arr.push(("v=" + Math.random()).replace(".", ""));
            return arr.join("&");
        }
        options = options || {};
        options.type = (options.type || "GET").toUpperCase();
        options.dataType = options.dataType || "json";
        var params = formatParams(options.data);

        //创建 - 非IE6 - 第一步
        if (window.XMLHttpRequest) {
            var xhr = new XMLHttpRequest();
        } else { //IE6及其以下版本浏览器
            var xhr = new ActiveXObject('Microsoft.XMLHTTP');
        }

        //接收 - 第三步
        xhr.onreadystatechange = function() {
            if (xhr.readyState == 4) {
                var status = xhr.status;
                if (status >= 200 && status < 300) {
                    options.success && options.success(xhr.responseText, xhr.responseXML);
                } else {
                    options.fail && options.fail(status);
                }
            }
        }

        //连接 和 发送 - 第二步
        if (options.type == "GET") {
            xhr.open("GET", options.url + "?" + params, true);
            xhr.send(null);
        } else if (options.type == "POST") {
            xhr.open("POST", options.url, true);
            //设置表单提交时的内容类型
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            xhr.send(params);
        }
    },
    trophy: {
        "0": {
            name: 'Kindle阅读器1个',
            aux: '好看不累'
        },
        "1": {
            name: 'Flower＋鲜花配送4次',
            aux: '爱自己'
        },
        "2": {
            name: '便携腰包',
            aux: ' 心爱之物要随身'
        },
        "3": {
            name: '玻璃水瓶',
            aux: '获得 “多喝水”'
        },
        "4": {
            name: '旅行分装瓶1套',
            aux: '空中飞人最爱'
        },
        "5": {
            name: '螺丝刀套装1套',
            aux: '男友力MAX'
        },
        "6": {
            name: '收纳盒1个',
            aux: '治愈强迫症'
        }
    },
    url: {
        'voteInfo': 'http://api.hu6.me/voteInfo',
        "vote": "http://api.hu6.me/vote",
        "mylottery": "http://api.hu6.me/mylottery",
        "statistics": "http://api.hu6.me/statistics",
        "lottery": "http://api.hu6.me/lottery",
        "setDetails": "http://api.hu6.me/setDetails"
    }
}